import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=0cbadc25&scoped=true&"
import script from "./FAQs.vue?vue&type=script&lang=js&"
export * from "./FAQs.vue?vue&type=script&lang=js&"
import style0 from "./FAQs.vue?vue&type=style&index=0&id=0cbadc25&prod&lang=scss&scoped=true&"
import style1 from "./FAQs.vue?vue&type=style&index=1&id=0cbadc25&prod&lang=css&"
import style2 from "./FAQs.vue?vue&type=style&index=2&id=0cbadc25&prod&lang=scss&scoped=true&"
import style3 from "./FAQs.vue?vue&type=style&index=3&id=0cbadc25&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbadc25",
  null
  
)

export default component.exports